import { gql } from "@apollo/client";

//* ລາຍງານການເຂົ້າຊົມຮ້ານ — ຍອດ + ຕາມເວລາ (ຮອງຮັບ startDate/endDate)
export const SHOP_VIEW_REPORT = gql`
  query ShopViewReport(
    $shop: ID!
    $days: Int
    $topLimit: Int
    $startDate: DateTime
    $endDate: DateTime
  ) {
    shopViewReport(
      shop: $shop
      days: $days
      topLimit: $topLimit
      startDate: $startDate
      endDate: $endDate
    ) {
      shopTotal
      rangeTotal
      today
      last7
      last30
      productViewsTotal
      byDay {
        date
        count
      }
      topProducts {
        id
        name
        image
        viewCount
      }
    }
  }
`;
